import React, { useState } from 'react';
import styled from 'styled-components';
import { Form } from 'react-final-form';
import { Column, Row, Card, Flex, Button } from '../design-system';
import { isExpired } from '../helpers/utils';
import FieldColumn from './FieldColumn';
import FieldText from './FieldText';
import { ExpiredCard } from './Expired';
import CardHeader from './CardHeader';
import CloseButton from './CloseButton';

const AbsolutePosButton = styled(CloseButton)`
  position: absolute;
  top: -12px;
  right: -19px;
`;

const RelativePosCard = styled(ExpiredCard)`
  position: relative;
  overflow: visible;
`;

interface SingleEntityProps {
  data: any;
  fields: any[];
  onSubmit: (values: any) => any;
  onClose: () => void;
  canEdit?: boolean;
}

const SingleEntity = ({
  data,
  fields,
  onSubmit,
  onClose,
  canEdit,
}: SingleEntityProps) => {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <RelativePosCard
      id={`entity-table`}
      expired={isExpired(data.expires)}
      mt={20}
      position="relative"
      overflow="visible"
    >
      <CardHeader
        title={data.name || data.title}
        onEditChange={setIsEditing}
        isEditing={isEditing}
        canEdit={canEdit}
      />
      <Card.Body>
        <Flex flexDirection="column">
          {isEditing ? (
            <Form
              initialValues={data}
              onSubmit={onSubmit}
              render={({ handleSubmit, submitting, pristine }) => (
                <form onSubmit={handleSubmit}>
                  {fields.map((field) => (
                    <FieldColumn key={field.name} {...field} />
                  ))}
                  <Button.Group mt={3} mb={6} pl={2}>
                    <Button
                      id="submit-button"
                      type="submit"
                      disabled={submitting || pristine}
                    >
                      Save
                    </Button>
                  </Button.Group>
                </form>
              )}
            />
          ) : (
            <Row>
              {fields.map((field) => (
                <Column key={field.name} mt={2} pb={3} width={400}>
                  <FieldText data={data} {...field} />
                </Column>
              ))}
            </Row>
          )}
        </Flex>
        <AbsolutePosButton
          variant="primaryText"
          type="button"
          onClick={onClose}
        />
      </Card.Body>
    </RelativePosCard>
  );
};

export default SingleEntity;
